import { companyDomainService } from "@/api/acendex/company";
import { imageConfig } from "@/config/config";
import { styled } from "@/styles/stitches.config";
import { Bell, Gift, Globe } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { UserAccount } from "../user-account";
import { Menu } from "./menu";

const OuterHeader = styled("div", {
  width: "100%",
  borderBottom: "1px solid rgba(0,0,0,0.1)",

  variants: {
    theme: {
      light: {
        backgroundColor: "$background",
        color: "$text",
      },
      dark: {
        backgroundColor: "$backgroundDark",
        color: "$textLight",
        borderBottom: "1px solid rgba(255,255,255,0.1)",
      },
    },
  },

  defaultVariants: {
    theme: "light",
  },
});

const HeaderWrapper = styled("header", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 $4",
  height: "64px",
  maxWidth: "1200px",
  margin: "0 auto",
});

const Logo = styled("div", {
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  img: {
    height: "24px",
  },
});

const RightSection = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "$3",
});

const IconButton = styled("button", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "32px",
  height: "32px",
  border: "none",
  borderRadius: "$1",
  backgroundColor: "transparent",
  cursor: "pointer",
  transition: "all 0.2s",

  variants: {
    theme: {
      light: {
        color: "$text",
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0.05)",
          color: "$primary",
        },
      },
      dark: {
        color: "$textLight",
        "&:hover": {
          backgroundColor: "rgba(255,255,255,0.1)",
          color: "$primary",
        },
      },
    },
  },

  defaultVariants: {
    theme: "light",
  },
});

interface PcHeaderProps {
  theme?: "light" | "dark";
}

export function PcHeader({ theme = "light" }: PcHeaderProps) {
  const requestCompanyDomain = companyDomainService.useFetch({
    isInit: true,
  });
  const navigate = useNavigate();

  return (
    <OuterHeader theme={theme}>
      <HeaderWrapper>
        <Logo>
          <img
            src={
              imageConfig.baseImageUrl +
              requestCompanyDomain.data.value?.companyLogoName
            }
            alt={requestCompanyDomain.data.value?.companyName}
          />
        </Logo>

        <Menu theme={theme} />

        <RightSection>
          {/* <IconButton theme={theme}>
            <Gift size={20} />
          </IconButton> */}
          <IconButton
            onClick={() => {
              navigate("/noice");
            }}
            theme={theme}
          >
            <Bell size={20} />
          </IconButton>
          <IconButton
            onClick={() => {
              navigate("/changelanguage");
            }}
            theme={theme}
          >
            <Globe size={20} />
          </IconButton>
          <UserAccount theme={theme} />
        </RightSection>
      </HeaderWrapper>
    </OuterHeader>
  );
}
